import styled from 'styled-components';
import { rem } from 'polished';
import { H6 } from 'baseline-ui/typography';

const LoaderMessage = styled(H6)`
    padding-top: ${rem(8)};
`;

export default LoaderMessage;
